import './sbrevents2/style';
import FormStructure from './sbrevents2/form_structure';

export default FormStructure;